<div class="fm-authentication">
  <div class="container-fluid">
    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-12">
        <div class="fm-fs-card fm-large-card">

          <div class="fm-auth-chead text-center">
            <div class="fm-logo">
              <a routerLink="/"><img src="images/logo.svg" width="213" alt="Forever Memories" /></a>
            </div>
            <h3 class="fm-head-32 fw-title">Create Your Family Space</h3>
            <p>This is where your family's stories will live. Choose a name that feels like home.</p>
          </div>

          <div class="fm-fs-wizard">
            <div class="fm-fs-stepform">
              <div class="fm-step-progress-info">
                <p class="mb-0 fm-stepcount-no">Steps {{ displayStep }} of 2</p>
                <p class="mb-0 fw-bold fm-step-percentage">{{ progressPercent }}% Completed</p>
              </div>

              <div class="fm-step-progress">
                <div class="fm-step-progress-bar" [style.width.%]="progressPercent"></div>
              </div>

              <div class="fm-step-form">
                <div class="fm-fs-step-content" [class.active]="currentStep() === 1">
                  <div class="row g-3 g-sm-4">
                    <div class="col-12">
                      <div class="form-group fm-basic-input fm-fileupload-group fm-family-logo-upload"
                           [class.fm-has-preview]="logoPreview()">
                        <!-- Upload zone — hidden once image is chosen -->
                        @if (!logoPreview()) {
                          <div class="fm-fileupload" [class.fm-drag-over]="isLogoDragOver()"
                               (dragover)="onLogoDragOver($event)"
                               (dragleave)="onLogoDragLeave($event)"
                               (drop)="onLogoDrop($event)">
                            <input type="file" class="fm-fuinput" id="fmFamilyImageInput" accept="image/*"
                                   (change)="onLogoChange($event)" />
                            <label for="fmFamilyImageInput" class="fm-upload-content text-center">
                              <img src="images/icons/fm-upload-icon.svg" alt="Upload Icon" />
                              <p class="mb-0 mt-2 pt-1">Drop your photo here, or <span class="fm-blue-txt">Browse</span></p>
                              <p class="mb-0 fm-upload-formats">Supported formats: JPG, JPEG, PNG, GIF, WebP, SVG</p>
                            </label>
                          </div>
                        }
                        <!-- Preview with Change / Remove actions -->
                        @if (logoPreview()) {
                          <div class="fm-img-preview-block">
                            <div class="fm-img-preview-thumb-wrap">
                              <img [src]="logoPreview()" class="fm-img-preview-thumb" alt="Family Logo Preview" />
                              @if (isLogoUploading()) {
                                <div class="fm-img-uploading-overlay">
                                  <span class="spinner-border spinner-border-sm" role="status"></span>
                                </div>
                              }
                            </div>
                            <div class="fm-img-preview-actions">
                              <input type="file" class="fm-fuinput" id="fmFamilyImageReInput" accept="image/*"
                                     (change)="onLogoChange($event)" />
                              <label for="fmFamilyImageReInput" class="fm-img-action-btn fm-img-change-btn" title="Change image"
                                     [class.disabled]="isLogoUploading()">
                                <img src="images/icons/fm-upload-icon.svg" alt="" />
                                {{ isLogoUploading() ? 'Uploading...' : 'Change' }}
                              </label>
                              <button type="button" class="fm-img-action-btn fm-img-remove-btn"
                                      (click)="removeLogo()" [disabled]="isLogoUploading()" title="Remove image">
                                &times; Remove
                              </button>
                            </div>
                            <p class="mb-0 fm-upload-meta mt-2">{{ logoMeta() }}</p>
                          </div>
                        }
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group" [formGroup]="step1Form">
                        <label for="fmfamilyName" class="form-label fm-label">
                          Family Name / Organization Name <span class="fm-required">*</span>
                        </label>
                        <input type="text" class="form-control" id="fmfamilyName"
                               placeholder="Enter Your Family Name"
                               formControlName="familyName"
                               [class.is-invalid]="s1['familyName'].invalid && s1['familyName'].touched" />
                        @if (s1['familyName'].invalid && s1['familyName'].touched) {
                          <div class="invalid-feedback">Family name is required (min 2 characters).</div>
                        }
                        <p class="fm-light mt-2 mb-0">This is what your family members will see when they're invited</p>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group" [formGroup]="step1Form">
                        <label for="fmWelcomeMessage" class="form-label fm-label">
                          Welcome Message <span class="fm-small">(Optional)</span>
                        </label>
                        <textarea class="form-control" id="fmWelcomeMessage" rows="4"
                                  placeholder="Write something here...."
                                  formControlName="welcomeMessage"></textarea>
                      </div>
                    </div>

                    <div class="col-12 mt-3">
                      <div class="form-group mt-1">
                        <div class="fm-notification-info">
                          <span class="fw-bold">You're the Admin:</span> You'll be able to invite family members,
                          manage permissions, and organize all your family's stories in one beautiful space.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="fm-fs-step-content" [class.active]="currentStep() === 2">
                  <div class="row g-3 g-sm-4">
                    <div class="col-12">
                      <!-- Member cards grid + Add Another tile -->
                      <div class="fm-fileupload-group fm-lovedone-section">
                        <div class="fm-filepreview fm-small-preview">

                          @for (member of addedMembers(); track $index) {
                            <div class="fm-step2-lovedone-preview">
                              <div class="fm-file-item">
                                @if (member.photoPreview) {
                                  <img [src]="member.photoPreview" alt="{{ member.firstName }} {{ member.lastName }}" />
                                } @else {
                                  <div class="fm-member-initials-bg">
                                    <span class="fm-member-initials-text">{{ getInitials(member.firstName, member.lastName) }}</span>
                                  </div>
                                }
                                <button type="button" class="fm-remove-member-btn" (click)="removeMember($index)" aria-label="Remove member">
                                  <img src="images/icons/fm-cancel-red.svg" alt="Remove" />
                                </button>
                                <p class="fm-file-name mb-0">{{ member.firstName }} {{ member.lastName }}<br /><span class="fm-relationship">{{ member.relationshipLabel }}</span></p>
                              </div>
                            </div>
                          }

                          <!-- Add Another Loved One tile -->
                          <button type="button" class="fm-file-item fm-step2-add-item" (click)="onAddAnotherLovedOne()" aria-label="Add another loved one">
                            <img src="images/icons/fm-plus-gr.svg" alt="Add Icon" />
                            <p class="mb-0">Add Another Loved one</p>
                          </button>

                        </div>
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <p class="mb-0 fm-light">You can add loved ones later from your dashboard</p>
                    </div>
                  </div>
                </div>

                <div class="fm-fs-step-content" [class.active]="currentStep() === 3">
                  <div class="row g-3 g-sm-4" [formGroup]="memberForm">
                    <div class="col-12">
                      <p class="fm-subtitle fm-add-loved mb-0">Add a loved one</p>
                    </div>
                    <div class="col-12">
                      <hr class="my-2 my-sm-0" />
                    </div>

                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-label fm-label">First Name <span class="fm-required">*</span></label>
                        <input type="text" class="form-control" placeholder="Enter First Name"
                               formControlName="firstName"
                               [class.is-invalid]="mf['firstName'].invalid && mf['firstName'].touched" />
                        @if (mf['firstName'].invalid && mf['firstName'].touched) {
                          <div class="invalid-feedback">First name is required.</div>
                        }
                      </div>
                    </div>

                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-label fm-label">Last Name <span class="fm-required">*</span></label>
                        <input type="text" class="form-control" placeholder="Enter Last Name"
                               formControlName="lastName"
                               [class.is-invalid]="mf['lastName'].invalid && mf['lastName'].touched" />
                        @if (mf['lastName'].invalid && mf['lastName'].touched) {
                          <div class="invalid-feedback">Last name is required.</div>
                        }
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-label fm-label">Relationship <span class="fm-required">*</span></label>
                        <select class="form-select" formControlName="relationshipTypeId"
                                [class.is-invalid]="mf['relationshipTypeId'].invalid && mf['relationshipTypeId'].touched">
                          <option [ngValue]="null" disabled>Select Relationship</option>
                          @for (item of relationshipOptions; track item.id) {
                            <option [ngValue]="item.id">{{ item.label }}</option>
                          }
                        </select>
                        @if (mf['relationshipTypeId'].invalid && mf['relationshipTypeId'].touched) {
                          <div class="invalid-feedback">Relationship is required.</div>
                        }
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-label fm-label">Email <span class="fm-required">*</span></label>
                        <input type="email" class="form-control" placeholder="Enter Email Address"
                               formControlName="email"
                               (input)="clearEmailExistsError()"
                               (blur)="onMemberEmailBlur()"
                               [class.is-invalid]="mf['email'].invalid && mf['email'].touched" />
                        @if (isEmailChecking()) {
                          <small class="text-muted">Validating email...</small>
                        }
                        @if (mf['email'].touched) {
                          @if (mf['email'].errors?.['required']) {
                            <div class="invalid-feedback d-block">Email is required.</div>
                          } @else if (mf['email'].errors?.['email']) {
                            <div class="invalid-feedback d-block">Please enter a valid email.</div>
                          } @else if (mf['email'].errors?.['emailExists']) {
                            <div class="invalid-feedback d-block">{{ memberEmailError() }}</div>
                          }
                        }
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-label fm-label">Phone <span class="fm-small">(Optional)</span></label>
                        <input type="tel" class="form-control" placeholder="(555) 555-5555"
                               formControlName="phone" appPhoneFormat />
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group">
                        <label class="form-label fm-label">Upload Photo <span class="fm-small">(Optional)</span></label>
                        <div class="form-group fm-fileupload-group fm-optional-fileupload">
                          @if (!optionalPhotoPreview()) {
                            <div class="fm-fileupload" [class.fm-drag-over]="isMemberPhotoDragOver()"
                                 (dragover)="onMemberPhotoDragOver($event)"
                                 (dragleave)="onMemberPhotoDragLeave($event)"
                                 (drop)="onMemberPhotoDrop($event)">
                              <input type="file" class="fm-fuinput" id="fmOptionalPhotoInput" accept="image/*"
                                     (change)="onOptionalPhotoChange($event)" />
                              <label for="fmOptionalPhotoInput" class="fm-upload-content text-center">
                                <img src="images/icons/fm-upload-icon.svg" alt="Upload Icon" />
                                <p class="mb-0 mt-2 pt-1">Drop your photo here, or <span class="fm-blue-txt">Browse</span></p>
                                <p class="mb-0 fm-upload-formats">Supported formats: JPG, JPEG, PNG, GIF, WebP, SVG</p>
                              </label>
                            </div>
                          }
                          @if (optionalPhotoPreview()) {
                            <div class="fm-img-preview-block">
                              <div class="fm-img-preview-thumb-wrap">
                                <img [src]="optionalPhotoPreview()" class="fm-img-preview-thumb fm-img-preview-thumb--circle" alt="Photo Preview" />
                                @if (isMemberPhotoUploading()) {
                                  <div class="fm-img-uploading-overlay fm-img-uploading-overlay--circle">
                                    <span class="spinner-border spinner-border-sm" role="status"></span>
                                  </div>
                                }
                              </div>
                              <div class="fm-img-preview-actions">
                                <input type="file" class="fm-fuinput" id="fmOptionalPhotoReInput" accept="image/*"
                                       (change)="onOptionalPhotoChange($event)" />
                                <label for="fmOptionalPhotoReInput" class="fm-img-action-btn fm-img-change-btn" title="Change photo"
                                       [class.disabled]="isMemberPhotoUploading()">
                                  <img src="images/icons/fm-upload-icon.svg" alt="" />
                                  {{ isMemberPhotoUploading() ? 'Uploading...' : 'Change' }}
                                </label>
                                <button type="button" class="fm-img-action-btn fm-img-remove-btn"
                                        (click)="removeMemberPhoto()" [disabled]="isMemberPhotoUploading()" title="Remove photo">
                                  &times; Remove
                                </button>
                              </div>
                              <p class="mb-0 fm-upload-meta mt-2">{{ optionalPhotoMeta() }}</p>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              @if (currentStep() === 1) {
                <div class="fm-step-form-btns pt-4 mt-1 mt-xl-3">
                  <div class="row g-3 g-sm-4">
                    <div class="col-auto col-sm-5">
                      <button type="button" class="fm-common-btn fm-border-btn fm-back w-100" (click)="skipToDashboard()">
                        Skip for Now
                      </button>
                    </div>
                    <div class="col col-sm-7">
                      <button type="button" class="fm-common-btn fm-next w-100" (click)="onFamilyContinue()">
                        Continue
                        <img class="fm-svg" src="images/icons/fm-arrow-ar.svg" alt="Right Arrow" />
                      </button>
                    </div>
                  </div>
                </div>
              }

              @if (currentStep() === 2) {
                <div class="fm-step-form-btns pt-4 mt-1 mt-xl-3">
                  <div class="row g-3 g-sm-4">
                    <div class="col-auto col-sm-5">
                      <button type="button" class="fm-common-btn fm-border-btn fm-back w-100" (click)="goBack()">Back</button>
                    </div>
                    <div class="col col-sm-7">
                      <button type="button" class="fm-common-btn w-100" [disabled]="isLoading()" (click)="onFinalSubmit()">
                        @if (isLoading()) {
                          <span class="spinner-border spinner-border-sm me-2" role="status"></span>Submitting...
                        } @else {
                          Submit & Continue
                          <img class="fm-svg" src="images/icons/fm-arrow-ar.svg" alt="Right Arrow" />
                        }
                      </button>
                    </div>
                  </div>
                </div>
              }

              @if (currentStep() === 3) {
                <div class="fm-step-form-btns fm-step3-btns pt-4 mt-1 mt-xl-3">
                  <div class="row g-3 g-sm-4">
                    <div class="col-12">
                      <button type="button" class="fm-common-btn fm-add-family w-100" (click)="onAddToFamily()">
                        Add to Family
                        <img class="fm-svg" src="images/icons/fm-arrow-ar.svg" alt="Right Arrow" />
                      </button>
                    </div>
                    <div class="col-auto col-sm-5">
                      <button type="button" class="fm-common-btn fm-border-btn fm-back w-100" (click)="goBack()">Back</button>
                    </div>
                    <div class="col col-sm-7">
                      <button type="button" class="fm-common-btn fm-secondary-btn fm-skip w-100" (click)="onSkipForNowFromMember()">
                        Skip for Now
                        <img class="fm-svg" src="images/icons/fm-arrow-ar.svg" alt="Right Arrow" />
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>